/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getPlatform = /* GraphQL */ `
  query GetPlatform($id: ID!) {
    getPlatform(id: $id) {
      id
      name
      description
      image {
        bucket
        region
        key
      }
      categories {
        items {
          id
          order
          name
          description
          platformId
          multipleCategoryUnits
          optional
          categoryUnits {
            items {
              id
              order
              name
              description
              developerDays
              graphicsDays
              categoryId
              image {
                bucket
                region
                key
              }
            }
            nextToken
          }
        }
        nextToken
      }
    }
  }
`;
export const listPlatforms = /* GraphQL */ `
  query ListPlatforms(
    $filter: ModelPlatformFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlatforms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        image {
          bucket
          region
          key
        }
        categories {
          items {
            id
            order
            name
            description
            platformId
            multipleCategoryUnits
            optional
            categoryUnits {
              items {
                id
                order
                name
                description
                developerDays
                graphicsDays
                categoryId
                image {
                  bucket
                  region
                  key
                }
              }
              nextToken
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCategory = /* GraphQL */ `
  query GetCategory($id: ID!) {
    getCategory(id: $id) {
      id
      order
      name
      description
      platformId
      multipleCategoryUnits
      optional
      categoryUnits {
        items {
          id
          order
          name
          description
          developerDays
          graphicsDays
          categoryId
          image {
            bucket
            region
            key
          }
        }
        nextToken
      }
    }
  }
`;
export const listCategorys = /* GraphQL */ `
  query ListCategorys(
    $filter: ModelCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategorys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        order
        name
        description
        platformId
        multipleCategoryUnits
        optional
        categoryUnits {
          items {
            id
            order
            name
            description
            developerDays
            graphicsDays
            categoryId
            image {
              bucket
              region
              key
            }
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCategoryUnit = /* GraphQL */ `
  query GetCategoryUnit($id: ID!) {
    getCategoryUnit(id: $id) {
      id
      order
      name
      description
      developerDays
      graphicsDays
      categoryId
      image {
        bucket
        region
        key
      }
    }
  }
`;
export const listCategoryUnits = /* GraphQL */ `
  query ListCategoryUnits(
    $filter: ModelCategoryUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCategoryUnits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        order
        name
        description
        developerDays
        graphicsDays
        categoryId
        image {
          bucket
          region
          key
        }
      }
      nextToken
    }
  }
`;
export const getConfiguration = /* GraphQL */ `
  query GetConfiguration($id: ID!) {
    getConfiguration(id: $id) {
      id
      developerRate
      graphicsRate
      configurationId
    }
  }
`;
export const listConfigurations = /* GraphQL */ `
  query ListConfigurations(
    $filter: ModelConfigurationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConfigurations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        developerRate
        graphicsRate
        configurationId
      }
      nextToken
    }
  }
`;
export const getEstimation = /* GraphQL */ `
  query GetEstimation($id: ID!) {
    getEstimation(id: $id) {
      id
      email
      platform
      configs
      cost
      createdAt
      updatedAt
    }
  }
`;
export const listEstimations = /* GraphQL */ `
  query ListEstimations(
    $filter: ModelEstimationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEstimations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        platform
        configs
        cost
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
